import React, { FC, Fragment } from 'react';
import { Card, CardActions, CardContent, Skeleton, Typography } from '@mui/material';
import DisabledCardState from '@components/Cards/DisabledCardState';
import { useUiState } from '@utils/UiStateHook';
import { usePotCard2Controller } from '@components/PotCard/UsePotCard2Controller';
import { DateTime } from 'luxon';
import { ToDate } from '@utils/DateUtils';

export interface PotCard2Props {
  groupId: number;
  groupStartDate: string | DateTime;
}

export const PotCard2: FC<PotCard2Props> = ({ groupId, groupStartDate }) => {
  const { potValue, disabledMessage, isLoading, enabled } = usePotCard2Controller(groupId, ToDate(groupStartDate));
  const uiState = useUiState(enabled);
  const backgroundStyles = {
    border: '1px solid',
    borderColor: uiState.backgroundColor,
    borderRadius: 16,
  };
  return (
    <Fragment>
      {isLoading && (
        <Card style={backgroundStyles} variant={'elevation'}>
          <CardContent>
            <Typography variant={'h4'} component={'p'}>
              <Skeleton width="80%" />
            </Typography>
            <Typography variant={'h3'} component={'p'}>
              <Skeleton width="60%" />
            </Typography>
          </CardContent>
          <CardActions sx={{ justifyContent: 'end', height: '90%' }}>
            <Skeleton variant="rectangular" width={100} height={40} />
          </CardActions>
        </Card>
      )}
      {!isLoading && (
        <Card style={backgroundStyles} variant={'elevation'}>
          <CardContent>
            <Typography variant="h5" component="div" color={uiState.color}>
              Pledge Pot
            </Typography>
            {!enabled && (
              <DisabledCardState disabledMessage={disabledMessage} src="/assets/svg/pot.svg" alt="Get stoked!" />
            )}
            {enabled && (
              <div className="card-content-wrapper">
                <img src={'/assets/svg/pot.svg'} alt={'Pot'} className="card-logo" />
                <Typography variant={'smallCursive'} component={'p'}>
                  {potValue}
                </Typography>
              </div>
            )}
          </CardContent>
        </Card>
      )}
    </Fragment>
  );
};
